/* Refrigeration Experts printable quote from the cart (blocks/re-cart-quote.liquid).
   Store prices are ex GST. Delivery uses the checkout freight sizes, marked by unit weight:
   Small (10 kg) $70 per order, Medium (50 kg) $250, Large (150 kg) $400, Extra large (300 kg) $600 per item, ex GST,
   and is shown as the maximum (the actual freight is confirmed before dispatch). */
(function () {
  if (window.reQuoteLoaded) return;
  window.reQuoteLoaded = true;

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-AU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function freightFor(items) {
    // Same as snippets/re-cart-delivery.liquid: per-item rates stop at the checkout caps (6 medium, 5 large, 4 extra large)
    var small = false, m = 0, l = 0, x = 0;
    items.forEach(function (it) {
      if (!it.requires_shipping) return;
      var kg = (it.grams || 0) / 1000;
      if (kg <= 0) return;
      if (kg <= 10) small = true;
      else if (kg <= 50) m += it.quantity;
      else if (kg <= 150) l += it.quantity;
      else x += it.quantity;
    });
    return (small ? 7000 : 0) + Math.min(m, 6) * 25000 + Math.min(l, 5) * 40000 + Math.min(x, 4) * 60000;
  }

  function build(cart) {
    var box = document.getElementById('re-quote-print');
    // Printing shows only direct children of <body> that are the quote, so move it there
    // (the cart can re-render, so drop any copy moved there earlier)
    document.querySelectorAll('body > #re-quote-print').forEach(function (el) { if (el !== box) el.remove(); });
    if (box.parentNode !== document.body) document.body.appendChild(box);
    var d = box.dataset;
    var now = new Date();
    var valid = new Date(now.getTime() + 14 * 86400000);
    var fmt = function (dt) { return dt.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' }); };
    var ref = 'Q-' + now.getFullYear().toString().slice(2) + ('0' + (now.getMonth() + 1)).slice(-2) + ('0' + now.getDate()).slice(-2) + '-' + ('0' + now.getHours()).slice(-2) + ('0' + now.getMinutes()).slice(-2);
    var items = cart.items || [];
    var subtotal = cart.items_subtotal_price != null ? cart.items_subtotal_price : cart.total_price;
    var freight = freightFor(items);
    var gst = Math.round((subtotal + freight) * 0.1);
    var total = subtotal + freight + gst;
    var rows = items.map(function (it) {
      return '<tr><td>' + esc(it.product_title) + (it.variant_title && it.variant_title !== 'Default Title' ? '<br><small>' + esc(it.variant_title) + '</small>' : '') +
        (it.sku ? '<br><small>Model / SKU: ' + esc(it.sku) + '</small>' : '') + '</td>' +
        '<td class="num">' + it.quantity + '</td><td class="num">' + money(it.final_price) + '</td><td class="num">' + money(it.final_line_price) + '</td></tr>';
    }).join('');
    box.innerHTML =
      '<div class="re-q__head"><div>' + (d.logo ? '<img src="' + esc(d.logo) + '" alt="Refrigeration Experts">' : '') +
      '<div class="re-q__biz">' + esc(d.business) + '<br>ABN ' + esc(d.abn) + '<br>' + esc(d.email) + (d.phone ? ' &middot; ' + esc(d.phone) : '') + ' &middot; ' + esc(d.web) + '</div></div>' +
      '<div><p class="re-q__title">Quote</p><div class="re-q__meta">Reference: ' + ref + '<br>Date: ' + fmt(now) + '<br>Valid until: ' + fmt(valid) + '</div></div></div>' +
      '<table class="re-q__table"><thead><tr><th>Item</th><th class="num">Qty</th><th class="num">Unit price (ex GST)</th><th class="num">Line total (ex GST)</th></tr></thead><tbody>' + rows + '</tbody></table>' +
      '<table class="re-q__totals"><tbody>' +
      '<tr><td>Subtotal (ex GST)</td><td class="num">' + money(subtotal) + '</td></tr>' +
      '<tr><td>Delivery, maximum (ex GST)</td><td class="num">' + money(freight) + '</td></tr>' +
      '<tr><td>GST (10%)</td><td class="num">' + money(gst) + '</td></tr>' +
      '<tr class="total"><td>Total (inc GST)</td><td class="num">' + money(total) + '</td></tr>' +
      '</tbody></table>' +
      '<div class="re-q__notes"><p>Prices are in Australian dollars. Delivery is shown as the maximum we charge for metro Sydney, Melbourne, Brisbane and Adelaide (within 20 km of the city centre); we confirm the actual freight before dispatch, and it is often less. Further out, and in other states, freight costs extra and is confirmed before dispatch.</p>' +
      '<p>Prices and stock are subject to change until the order is placed. Equipment is supplied only; installation and connection are not included.</p>' +
      '<p>To order, add these items to your cart at ' + esc(d.web) + ' or reply to ' + esc(d.email) + ' with this reference.</p></div>';
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('[data-re-quote-print]')) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      build(cart);
      document.body.classList.add('re-printing');
      setTimeout(function () { window.print(); }, 150);
    });
  });
  window.addEventListener('afterprint', function () { document.body.classList.remove('re-printing'); });
})();
